export const formatTimeHhMmSsInput = (value: string) => {
  const digits = String(value ?? '').replace(/[^\d]/g, '').slice(0, 6);
  const hh = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const ss = digits.slice(4, 6);

  if (digits.length <= 2) return hh;
  if (digits.length <= 4) return `${hh}:${mm}`;
  return `${hh}:${mm}:${ss}`;
};

export const formatTimeOfDay = (value?: string | null, fallback = '—') => {
  if (!value) {
    return fallback;
  }

  const trimmedValue = String(value).trim();
  const match = trimmedValue.match(/^(\d{1,2}):(\d{2})(?::\d{2}(?:\.\d+)?)?$/);

  if (!match) {
    return trimmedValue || fallback;
  }

  const hours24 = Number.parseInt(match[1], 10);
  const minutes = match[2];

  if (!Number.isFinite(hours24) || hours24 < 0 || hours24 > 23) {
    return trimmedValue;
  }

  const period = hours24 >= 12 ? 'PM' : 'AM';
  const hours12 = hours24 % 12 || 12;

  return `${hours12}:${minutes} ${period}`;
};
